export default [
  {
    title: 'Transactions',
    route: 'transactions',
    icon: 'GridIcon',
  },
]
